import React, { useState, useEffect } from "react";
import "./ListStyles.css";
import useSessionStorage from "./useSessionStorage";

import { useNavigate } from "react-router-dom";

import useAxios from "./useAxios";

const TablesList = () => {
  const navigate = useNavigate();
  const [axios] = useAxios(true);

  const [tenant] = useSessionStorage("tenant");

  const [tables, setTables] = useState([]);

  useEffect(() => {
    axios.get("tables", setTables);
  }, []);

  return (
    <div className="list-container">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 12,
          marginBottom: 24,
        }}
      >
        <h2 style={{ margin: 0 }}>Tables</h2>
        <button
          className="edit-button"
          aria-label="Add New Table"
          style={{
            fontSize: 24,
            padding: "4px 14px",
            margin: 0,
            lineHeight: 1,
          }}
          onClick={() => navigate("/configuration/table/0")}
        >
          +
        </button>
      </div>
      <table className="list-table">
        <thead>
          <tr>
            {tenant.super ? <th>Tenant</th> : null}
            <th>Name</th>
            <th>Short Code</th>
            <th>Game Type</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {tables.map((table) => (
            <tr key={table.id}>
              {tenant.super ? <td>{table.tenant.name}</td> : null}
              <td>{table.name}</td>
              <td>{table.shortId}</td>
              <td>{table.gameType?.description || "-"}</td>
              <td>
                <button
                  className="edit-button"
                  onClick={() => navigate("/configuration/table/" + table.id)}
                >
                  Edit
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TablesList;
